"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractEntityFilter_1 = require("../../core/model/overview/AbstractEntityFilter");

var PromotionFilter =
/*#__PURE__*/
function (_AbstractEntityFilter) {
  _inherits(PromotionFilter, _AbstractEntityFilter);

  function PromotionFilter(ids, externalIds, states, excludeStates, promotionTypeIds, promotionWeekType, years, weeks, select, groupOfSitesIds, storeSpecifications, kpis, effectInterval, validityInterval, filter, themeIds, stateFlags, promoSplitOptions, dateToGte, affectsDate) {
    var _this;

    _classCallCheck(this, PromotionFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionFilter).call(this));
    _this.ids = ids;
    _this.externalIds = externalIds;
    _this.states = states;
    _this.excludeStates = excludeStates;
    _this.promotionTypeIds = promotionTypeIds;
    _this.promotionWeekType = promotionWeekType;
    _this.years = years;
    _this.weeks = weeks;
    _this.select = select;
    _this.groupOfSitesIds = groupOfSitesIds;
    _this.storeSpecifications = storeSpecifications;
    _this.kpis = kpis;
    _this.effectInterval = effectInterval;
    _this.validityInterval = validityInterval;
    _this.filter = filter;
    _this.themeIds = themeIds;
    _this.stateFlags = stateFlags;
    _this.promoSplitOptions = promoSplitOptions;
    _this.dateToGte = dateToGte;
    _this.affectsDate = affectsDate;
    return _this;
  }

  return PromotionFilter;
}(AbstractEntityFilter_1.AbstractEntityFilter);

exports.PromotionFilter = PromotionFilter;
PromotionFilter.EMPTY = new PromotionFilter();